export const _en = {
    name: {
        label: "Name"
    },
    color: {
        label: "Color"
    }
};

export const _fr = {
    name: {
        label: "Nom"
    },
    color: {
        label: "Couleur"
    }
};